import { createClient as createSupabaseClient, type SupabaseClient } from '@supabase/supabase-js';

// Type declaration for window.__ENV__
declare global {
  interface Window {
    __ENV__?: {
      BUN_PUBLIC_SUPABASE_URL?: string;
      BUN_PUBLIC_SUPABASE_ANON_KEY?: string;
      VITE_SUPABASE_URL?: string;
      VITE_SUPABASE_ANON_KEY?: string;
    };
  }
}

// Singleton instance cache
let supabaseClient: SupabaseClient | null = null;

const getEnvVars = () => {
  // Try multiple sources for environment variables
  // 1. Window object (injected by server)
  // 2. import.meta.env (Bun/Vite)
  // 3. process.env (Node.js/Bun server-side)
  const env = typeof window !== 'undefined' ? window.__ENV__ : undefined;
  
  const supabaseUrl =
    env?.BUN_PUBLIC_SUPABASE_URL ||
    env?.VITE_SUPABASE_URL ||
    import.meta.env?.BUN_PUBLIC_SUPABASE_URL ||
    import.meta.env?.VITE_SUPABASE_URL ||
    (typeof process !== 'undefined' ? process.env.BUN_PUBLIC_SUPABASE_URL : undefined) ||
    (typeof process !== 'undefined' ? process.env.VITE_SUPABASE_URL : undefined);

  const supabaseAnonKey =
    env?.BUN_PUBLIC_SUPABASE_ANON_KEY ||
    env?.VITE_SUPABASE_ANON_KEY ||
    import.meta.env?.BUN_PUBLIC_SUPABASE_ANON_KEY ||
    import.meta.env?.VITE_SUPABASE_ANON_KEY ||
    (typeof process !== 'undefined' ? process.env.BUN_PUBLIC_SUPABASE_ANON_KEY : undefined) ||
    (typeof process !== 'undefined' ? process.env.VITE_SUPABASE_ANON_KEY : undefined);

  return { supabaseUrl, supabaseAnonKey };
};

export const createClient = (): SupabaseClient => {
  // Return cached instance if it exists
  if (supabaseClient) {
    return supabaseClient;
  }

  const { supabaseUrl, supabaseAnonKey } = getEnvVars();

  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('Supabase environment variables missing:', {
      hasUrl: !!supabaseUrl,
      hasKey: !!supabaseAnonKey,
      hasWindowEnv: !!window.__ENV__,
    });
    throw new Error(
      'Configuració de Supabase no disponible. Contacta amb l\'administrador.'
    );
  }

  // Create and cache the client instance
  supabaseClient = createSupabaseClient(supabaseUrl, supabaseAnonKey);
  return supabaseClient;
};
